module.exports = __webpack_public_path__ + "static/newmovieseverymonth-576834151e1b5dab1600e40e2e283feb.gif";